/**
 * Admin Route Component
 * Wraps routes that require an admin session.
 * Redirects to /admin-login.
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const AdminRoute = ({ children }) => {
  const { isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingSpinner message="Loading..." />;
  }

  if (!isAdmin) {
    return <Navigate to="/admin-login" state={{ from: location.pathname }} replace />;
  }

  return children;
};

export default AdminRoute;
